/**
 * Tutor Analytics API client.
 * Uses the gateway axios client with interceptors for auth/tenant headers.
 */

import { createHttpClient } from '../../api/http';
import { serviceUrls } from '../../config/serviceUrls';
import type { TutorAnalyticsSummary } from '../types/tutorAnalytics';

const client = createHttpClient(serviceUrls.gateway);

/**
 * Get current user's tutor analytics summary
 */
export async function getMyTutorAnalytics(days: number): Promise<TutorAnalyticsSummary> {
  const response = await client.get(`/v1/tutor/analytics/me/summary`, {
    params: { days },
  });
  return response.data;
}

/**
 * Get a specific student's tutor analytics summary
 */
export async function getStudentTutorAnalytics(
  studentId: string,
  days: number
): Promise<TutorAnalyticsSummary> {
  const response = await client.get(`/v1/tutor/analytics/student/${studentId}/summary`, {
    params: { days },
  });
  return response.data;
}